const cultureCharacteristics = [
  {
    label: 'Competitief',
    key: 'competitief',
    description:
      'Men bereikt veel in het werk en vindt het leuk om prestaties te vergelijken met anderen.',
  },
  {
    label: 'Collegiaal',
    key: 'sociaal_collegiaal',
    description: 'Men doet iets voor anderen en is dienstverlenend.',
  },
  {
    label: 'Lerende Organisatie',
    key: 'lerende_organisatie',
    description: 'Men blijft zichzelf ontwikkelen en blijft leren in het werk.',
  },
  {
    label: 'Innovatief',
    key: 'innovatief',
    description: 'Men is creatief en bedenkt nieuwe oplossingen.',
  },
  {
    label: 'Georganiseerd',
    key: 'georganiseerd',
    description: 'Men brengt structuur aan.',
  },
  {
    label: 'Zorgvuldig nadenkend',
    key: 'zorgvuldig_nadenkend',
    description: 'Men denkt zorgvuldig na voordat gehandeld wordt.',
  },
  {
    label: 'Winstgericht',
    key: 'winstgericht',
    description: 'Men wordt gestimuleerd door financiële beloning en inkomen.',
  },
  {
    label: 'Complimenteus',
    key: 'complimenteus',
    description: 'Men geeft waardering en erkenning aan anderen.',
  },
  {
    label: 'Resultaatgericht',
    key: 'resultaatgericht',
    description: 'Men ziet concrete resultaten van eigen werkzaamheden.',
  },
  {
    label: 'Maatschappelijk',
    key: 'maatschappelijk',
    description:
      'Men levert een bijdrage die betekenisvol is voor anderen in de maatschappij.',
  },
  {
    label: 'Kwaliteitsgericht',
    key: 'kwaliteitsgericht',
    description:
      'Men levert een hoge kwaliteit van werk en stelt hoge eisen aan het afgeleverde werk.',
  },
  {
    label: 'Creatief',
    key: 'creatief',
    description:
      'Men is creatief en vernieuwend bezig en heeft ruimte om te bedenken en te ontwikkelen.',
  },
  {
    label: 'Machtsgericht',
    key: 'machtsgericht',
    description: 'Men wilt graag hogerop komen.',
  },
  {
    label: 'Ondernemend',
    key: 'ondernemend',
    description: 'Men initieert acties, projecten en ondernemingen.',
  },
  {
    label: 'Vrijheid',
    key: 'vrijheid',
    description: 'Men kan zelf bepalen wat er gedaan wordt.',
  },
  {
    label: 'Samenwerkend',
    key: 'samenwerkend',
    description:
      'Men gaat om met andere mensen en maakt onderdeel uit van een sociaal geheel met een prettige sfeer.',
  },
  {
    label: 'Dynamisch',
    key: 'dynamisch',
    description:
      'Men werkt hard, heeft veel te doen en werkt in een drukke omgeving.',
  },
  {
    label: 'Ambitieus',
    key: 'ambitieus',
    description: 'Men richt zich liever op het werk dan op het priveleven.',
  },
  {
    label: 'Eerlijk',
    key: 'eerlijk',
    description: 'Men zegt de waarheid, blijft eerlijk en komt afspraken na.',
  },
  {
    label: 'Compliant',
    key: 'compliant',
    description: 'Men houdt zich aan de geldende regels.',
  },
]

export default cultureCharacteristics
